import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { getColorForCount } from '../utils/heatmapUtils';

interface HeatmapCellProps {
    count: number;
    maxCount: number;
    tooltipTitle: string;
    size?: number;
    onClick?: () => void;
}

export const HeatmapCell = ({
    count,
    maxCount,
    tooltipTitle,
    size = 12,
    onClick,
}: HeatmapCellProps) => (
    <Tooltip title={tooltipTitle} placement="top">
        <Box
            data-testid="heatmap-cell"
            onClick={onClick}
            sx={{
                width: size,
                height: size,
                backgroundColor: getColorForCount(count, maxCount),
                border: '1px solid #d1d5da',
                borderRadius: 0.5,
                cursor: 'pointer',
                '&:hover': {
                    border: '1px solid #000',
                },
            }}
        />
    </Tooltip>
);

interface HeatmapLegendProps {
    maxCount: number;
    size?: number;
}

export const HeatmapLegend = ({ maxCount, size = 12 }: HeatmapLegendProps) => (
    <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="caption" sx={{ fontSize: 11 }}>
            Less
        </Typography>
        {[0, 0.25, 0.5, 0.75, 1].map(intensity => (
            <Box
                key={intensity}
                sx={{
                    width: size,
                    height: size,
                    backgroundColor: getColorForCount(
                        Math.ceil(maxCount * intensity),
                        maxCount
                    ),
                    border: '1px solid #d1d5da',
                    borderRadius: 0.5,
                }}
            />
        ))}
        <Typography variant="caption" sx={{ fontSize: 11 }}>
            More
        </Typography>
    </Box>
);

interface MonthRowProps {
    monthName: string;
    children: React.ReactNode;
}

export const MonthRow = ({ monthName, children }: MonthRowProps) => (
    <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography
            variant="subtitle2"
            sx={{
                minWidth: 100,
                fontSize: 12,
                fontWeight: 600,
            }}
        >
            {monthName}
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={0.25}>
            {children}
        </Box>
    </Box>
);
